/** File types the composer accepts. Kept in sync with {@link FILE_INPUT_ACCEPT}. */
export const VALID_MIME_TYPES = new Set([
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/bmp',
    'application/pdf',
    'application/msword', // .doc
]);

/** The `accept` attribute for the file input — the same set as {@link VALID_MIME_TYPES}. */
export const FILE_INPUT_ACCEPT =
    'image/jpeg,image/png,image/gif,image/bmp,application/pdf,application/msword';

export const MAX_FILE_BYTES = 10 * 1024 * 1024;
export const MAX_UPLOADS = 10;

/** Longest-edge pixel count below which an image is flagged as possibly too low-resolution. */
export const LOW_RES_THRESHOLD = 800;
